import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Reservation, ReservationsService, ReservationStatus} from "../../../services/reservations.service";
import {ActivatedRoute} from "@angular/router";
import {ConfirmReservationModalComponent} from "../reservations-list/modals/confirm-reservation-modal.component";
import {RejectReservationModalComponent} from "../reservations-list/modals/reject-reservation-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ConfirmContactModalComponent} from "../reservations-list/modals/confirm-contact-modal.component";
import {ReservationSummaryModalComponent} from "../reservation-summary-modal/reservation-summary-modal.component";


enum Action {
  CONFIRM_RESERVATION = 'confirm',
  REJECT_RESERVATION = 'reject',
  CONFIRM_CONTACT = 'contact',
  SUBMIT_SUMMARY = 'summary',
}

@Component({
  selector: 'reservation-details',
  templateUrl: 'reservation-details.component.html',
  styleUrls: ['./reservation-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReservationDetailsComponent implements OnInit {
  reservation: Reservation;

  constructor(private route: ActivatedRoute, private reservationsService: ReservationsService, private modalService: NgbModal) {
  }

  ngOnInit() {
    this.reservationsService.getReservationsDetails(this.getReservationId()).subscribe(
      (reservation) => {
        this.reservation = reservation;
        const action = this.route.snapshot.queryParamMap.get('action');
        if (action) {
          if (action == Action.CONFIRM_RESERVATION && reservation.status == ReservationStatus.WAITING) {
            this.showConfirmModal();
          } else if (action == Action.REJECT_RESERVATION && reservation.status == ReservationStatus.WAITING) {
            this.showRejectModal();
          } else if (action == Action.CONFIRM_CONTACT && reservation.chef_should_contact_with_customer) {
            this.showContactConfirmModal();
          } else if (action == Action.SUBMIT_SUMMARY && reservation.chef_can_submit_summary) {
            this.showReservationSummaryModal();
          }
        }
      }
    );
  }

  fetchData() {
    this.reservationsService.getReservationsDetails(this.getReservationId()).subscribe(
      (data) => this.reservation = data
    );
  }

  getReservationId() {
    return parseInt(this.route.snapshot.paramMap.get('id'))
  }

  showConfirmModal() {
    ConfirmReservationModalComponent
      .open(this.modalService, this.reservation)
      .filter(result => result)
      .subscribe(_ => this.fetchData());
  }

  showRejectModal() {
    RejectReservationModalComponent
      .open(this.modalService, this.reservation)
      .filter(result => result)
      .subscribe(_ => this.fetchData());
  }

  showContactConfirmModal() {
    ConfirmContactModalComponent
      .open(this.modalService, this.reservation)
      .filter(result => result)
      .subscribe(_ => this.fetchData());
  }

  showReservationSummaryModal() {
    ReservationSummaryModalComponent
      .open(this.modalService, this.reservation)
      .filter(result => result)
      .subscribe(_ => this.fetchData());
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/reservation-details/reservation-details.component.ts